import axios, { AxiosRequestConfig } from 'axios';

interface Urls {
  infoUrl: string;
  errorUrl: string;
}

let logInstance: LogService | null = null;

const getHeaders = (traceId: string, accessToken: string): AxiosRequestConfig => {
  return {
    headers: {
      'x-amzn-trace-id': traceId,
      Authorization: accessToken,
    },
  };
};

class LogService {
  private infoUrl: string;
  private errorUrl: string;
  private traceId: string;
  private accessToken: string;

  constructor(urls: Urls, traceId: string, accessToken: string) {
    this.infoUrl = urls.infoUrl;
    this.errorUrl = urls.errorUrl;
    this.traceId = traceId;
    this.accessToken = accessToken;
  }

  setTraceId = (traceId: string): void => {
    this.traceId = traceId;
  };

  sendInfoLog = async (data: any): Promise<void> => {
    try {
      await axios.post(this.infoUrl, data, getHeaders(this.traceId, this.accessToken));
    } catch (err) {
      throw new Error('Logservice failed to sendInfoLog');
    }
  };

  sendErrorLog = async (data: any): Promise<void> => {
    try {
      await axios.post(this.errorUrl, data, getHeaders(this.traceId, this.accessToken));
    } catch (err) {
      throw new Error('Logservice failed to sendErrorLog');
    }
  };
}

export default {
  init: (urls: Urls, traceId: string, accessToken: string): LogService => {
    if (!logInstance) {
      logInstance = new LogService(urls, traceId, accessToken);
    }
    return logInstance as LogService;
  },

  getInstance: (): LogService | null => {
    return logInstance;
  },
};
